<template>
  <div class="data account" v-loading="loading">
    <div class="datafrom">
      <el-form ref="queryForm" :model="queryParams" size="small" :inline="true" label-width="auto">
        <el-form-item  prop="keyword">
          <span slot="label">
            <span style="color:#333333;font-size: 18px;font-weight: bold;">姓名:</span>
          </span>

          <el-input
            v-model="queryParams.name"
            placeholder="请输入姓名"
            clearable
            style="height: 32px"
          />
        </el-form-item>
        <el-form-item  prop="keyword">
          <span slot="label">
            <span style="color:#333333;font-size: 18px;font-weight: bold;">手机号:</span>
          </span>
          <el-input
            v-model="queryParams.phone"
            placeholder="请输入手机号"
            clearable
            style="height: 32px"
          />
        </el-form-item>
        <el-form-item style="">
          <el-button type="primary" size="mini" @click="handleQuery">查询</el-button>
          <el-button size="mini" @click="handleAdd">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="add">
      <el-button type="primary" icon="el-icon-plus" @click="add">新建</el-button>
    </div>
    <div class="list">
      <div class="nav">
        <div class="nav-max">
          <div class="nav-left"></div>
          <div class="nav-center">账户列表</div>
        </div>
      </div>
      <template>
        <el-table
          :data="tableData"
          :header-cell-style="{background:'#EEF5FF',height:'60px',color:'#333333','text-align': 'center',}"
        >
          style="width: 100%">
          <el-table-column label="编号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column  label="角色名" align="center" show-overflow-tooltip width="180">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: center;align-items: center">
                <div v-for="(item,index) in scope.row.rolesList" :key="index">
                <span>
                  {{item.name}}{{index+1 < scope.row.rolesList.length?",":""}}
                </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="userFname"
            align="center"
            show-overflow-tooltip
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="mobile"
            align="center"
            show-overflow-tooltip
            label="手机号码">
          </el-table-column>
          <el-table-column label="角色"  align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.userType == 3">超级管理员</span>
              <span v-if="scope.row.userType == 2">学校管理员</span>
              <span v-if="scope.row.userType == 1">普通用户</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"  align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.createdAt?$moment(scope.row.createdAt*1000).format('YYYY-MM-DD'):0}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" width="180">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
              <el-button size="mini" type="text" @click="forbidden(scope.row)">
                <span v-if="scope.row.status==0">禁用</span>
                <span v-if="scope.row.status==1">已禁用</span>
                <span v-if="scope.row.status==2">异常</span>
              </el-button>
              <el-button size="mini" type="text" @click="Estoppel(scope.row)">{{!scope.row.bannedToPost?'禁言':'已禁言'}}</el-button>
              <el-button size="mini" type="text" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </template>

    </div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetForm('ruleForm')"
      width="550px"
      center>
      <div slot="title" class="header-title" :style="{ 'color': '#333333'}">
        <div style="text-align: left">{{ title }}</div>
      </div>

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" >
        <el-form-item label="手机号码：" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="用户名：" prop="username">
          <el-input v-model="ruleForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="登录密码：" prop="password" >
          <el-input v-model="ruleForm.password" placeholder="请输入登录密码" type="password" ></el-input>
        </el-form-item>
        <el-form-item label="账户类型：" prop="rolename" >
          <el-select v-model="ruleForm.rolename" placeholder="请选择账户类型" style="width: 100%" clearable>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校：" prop="school" v-if="schoolbold">
          <el-select v-model="ruleForm.school" placeholder="请选择学校" style="width: 100%" clearable>
            <el-option
              v-for="item in schoollist"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" required >
          <div>
            <el-button @click="resetForm('ruleForm')" style="width: 130px;margin-left: 30px">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')"  style="width: 130px;margin-left: 20px">确定</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import luse from '../assets/luse.png'
import zise from '../assets/zise.png'
import chense from '../assets/chense.png'
import luitem from '../assets/luitem.png'
import ziitem from '../assets/ziitem.png'
import chenitem from '../assets/chenitem.png'
import top from '../assets/top.png'
import {getuserlist, createuser, updateuser, Estoppeluser, Banuser, Deleteuser} from "../utils/account";

export default {
  data(){
    return{
      luse,
      zise,
      chense,
      luitem,
      ziitem,
      chenitem,
      top,
      tableData: [],
      currentPage4:1,
      queryParams:{
        name:'',
        phone:'',
        pagesize:1,
        pageNumber:10
      },
      loading:false,
      total:0,
      centerDialogVisible: false,
      ruleForm: {
        username: '',
        name: '',
        phone: '',
        password: '',
        rolename:'',
        school:'',
      },
      rules: {
        // username: [
        //   { required: true, message: '请输入用户名', trigger: 'blur' },
        // ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        rolename: [
          { required: true, message: '请选择账户类型', trigger: 'blur' }
        ],
        school:[
          { required: true, message: '请选择学校', trigger: 'blur' }
        ]
      },
      options: [{
        value: '1',
        label: '普通类型'
      }, {
        value: '2',
        label: '学校管理员'
      }, {
        value: '3',
        label: '超级管理员'
      }],
      schoollist:[{
          value: '1',
          label: '无锡职业技术学院'
        }, {
          value: '2',
          label: '上海巅思智能科技'
        },
      ],
      title:'',
      schoolbold:false,
      addorupdate:null,
      updateobj:{},
    }
  },
  created() {
    if(sessionStorage.getItem('userType') == '2'){
      this.options = [{
        value: '1',
        label: '普通类型'
      }, {
        value: '2',
        label: '学校管理员'
      }]
    }
    if(sessionStorage.getItem('userType') == '3'){
      this.schoolbold = true
    }else{
      this.schoolbold = false
    }
    this.getlist()
  },
  methods: {
    getlist(){
      this.loading = true
      getuserlist(this.queryParams.name,this.queryParams.phone,this.queryParams.pagesize,this.queryParams.pageNumber).then(response => {
        console.log(response.usersList)
        this.tableData = response.usersList
        this.total = response.totalRows
        this.loading = false
      }).catch(err=>{
        if(err.code == 16){
          sessionStorage.removeItem('token');
          this.$router.push('/login')
          this.loading = false
        }
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.queryParams.pageNumber = val
      this.getlist()
    },
    handleCurrentChange(val) {
      this.queryParams.pagesize = val
      this.getlist()
    },
    handleAdd(){
      this.queryParams.phone = ""
      this.queryParams.name = ""
    },
    handleQuery(){
      this.getlist()
    },
    //新增
    add(){
      this.rules.password[0].required = true
      this.addorupdate = 1
      this.ruleForm = {
        username: '',
        name: '',
        phone: '',
        password: '',
        rolename:'',
        school:'',
      }
      if (this.$refs['form']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.centerDialogVisible = true
      this.title = '新建账户'
    },
    //编辑
    edit(row){
      this.rules.password[0].required = false
      this.updateobj = row
      this.addorupdate = row.id
      console.log(row)
      this.title = '修改账户'
      this.centerDialogVisible = true
      this.ruleForm.username = row.userName
      this.ruleForm.name = row.userFname
      this.ruleForm.phone = row.mobile
      if(row.schoolInfo){
        if(row.schoolInfo.name == "无锡职业技术学院"){
          this.ruleForm.school = "1"
        }else if(row.schoolInfo.name == "上海巅思智能科技"){
          this.ruleForm.school = "2"
        }else{
        }
      }
      if(row.userType == '1'){
        this.ruleForm.rolename = "1"
      }else if(row.userType == '2'){
        this.ruleForm.rolename = "2"
      }else if(row.userType == '3'){
        this.ruleForm.rolename = "3"
      }else{

      }
    },
    //禁用
    forbidden(row){
      console.log(row)
      row.status = !row.status
      const data = {
        id:row.id,
        status:row.status
      }
      Banuser(data).then(res=>{
        this.getlist()
      }).catch(err=>{
        this.$message.error('操作失败')
        row.status = !row.status
        if(err.code == 16){
          sessionStorage.removeItem('token');
          this.$router.push('/login')
        }
      })
    },
    //禁言
    Estoppel(row){
        row.bannedToPost = !row.bannedToPost
        const data = {
          id:row.id,
          bannedToPost:row.bannedToPost
        }
        Estoppeluser(data).then(res=>{
          this.getlist()
        }).catch(err=>{
          this.$message.error('操作失败')
          row.bannedToPost = !row.bannedToPost
          if(err.code == 16){
            sessionStorage.removeItem('token');
            this.$router.push('/login')
          }
        })
    },
    //删除
    del(row){
      this.$confirm('确定删除该项数据吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Deleteuser(row).then(res=>{
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getlist()
        }).catch(err=>{
          if(err.code == 16){
            sessionStorage.removeItem('token');
            this.$router.push('/login')
          }
        })
      }).catch(() => {
      });
    },
    //提交入库
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.addorupdate == 1){ //新增
            createuser(this.ruleForm).then(response => {
              this.$message.success('操作成功')
              this.getlist()
              this.centerDialogVisible = false
            }).catch(err=>{
              if(err.code == 16){
                sessionStorage.removeItem('token');
                this.$router.push('/login')
              }
              this.centerDialogVisible = false
              this.getlist()
            })
          }else{ //修改
            this.ruleForm.id = this.updateobj.id
            updateuser(this.ruleForm).then(response => {
              console.log(2222222)
              this.$message.success('操作成功')
              this.getlist()
              this.centerDialogVisible = false
            }).catch(err=>{
              if(err.code == 16){
                sessionStorage.removeItem('token');
                this.$router.push('/login')
                this.centerDialogVisible = false
              }
              this.centerDialogVisible = false
              this.getlist()
            })
          }

        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm = {
        username: '',
        name: '',
        phone: '',
        password: '',
        rolename:'',
        school:'',
      }
      if (this.$refs['form']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.centerDialogVisible = false
    }
  },
}
</script>
<style scoped>
.account .el-form-item{
  margin-bottom: 0px;
}
.account .el-dialog__header{
  padding: 0 !important;
}
</style>
<style lang='scss' scoped>
.data{
  width:calc(100% - 450px);
  height: 100vh;
  padding: 20px 60px 0 60px;
  overflow: auto;
  .datafrom{
    //height: 100px;
    min-width: 520px;
    background-color: #FFFFFF;
    padding: 34px 0px 34px 25px;
    display: flex;
    align-items: center;
    //overflow: auto;
  }
  .add{
    padding: 20px 0;
  }
  .list{
    //min-width: 600px;
    //height: 640px;
    min-width: 400px;
    background: #FFFFFF;
    //overflow: auto;
    //overflow: hidden;
    box-shadow: 3px 6px 6px 1px rgba(192,205,241,0.3);
    border-radius: 19px 19px 19px 19px;
    opacity: 1;
    border: 1px solid rgba(235,235,235,0.5);
    margin-bottom: 100px;
    padding: 32px 67px;
    .nav{
      height: 95px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .nav-max{
        display: flex;
        align-items: center;
        .nav-left{
          width: 6px;
          height: 30px;
          background: #578DE7;
          opacity: 1;
          margin-top: 6px;
          border-radius: 2px;
        }
        .nav-center{
          font-size: 32px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-left: 32px;
        }
      }
      .nav-export{
        width: 120px;
        height: 56px;
        background: #63ACFF;
        border-radius: 14px 14px 14px 14px;
        opacity: 1;
        font-size: 20px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .block{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 36px;
    min-width: 320px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/account.vue